module.exports = "<i class=\"fas fa-spinner fa-spin\"></i>\n"